import createNotificationsSlice, {
  initialState,
} from '@sv-support-sdk/store/src/modules/notifications/slices';

const notificationsSlice = createNotificationsSlice({
  name: 'notifications',
  initialState: { ...initialState },
  reducers: {},
});

export const { addNotification, removeNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
